module.exports = __webpack_public_path__ + "img/placeholder.55d67d17.png";